import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../index";

import { Transaction } from "../../services/transactions/dto/transactions.dto";
import { TransactionsAPI } from "../../services/transactions/transactions.service";

interface transactionsState {
	loadingTransactions: boolean;
	transactions: Transaction[];
	adminTransactions: Transaction[];
	totalItems: number;
}

const initialState: transactionsState = {
	loadingTransactions: false,
	transactions: [],
	adminTransactions: [],
	totalItems: 0
};

const transactionsSlice = createSlice({
	name: "transactions",
	initialState,
	reducers: {},
	extraReducers: builder =>
		builder
			.addMatcher(TransactionsAPI.endpoints.getTransactions.matchPending, state => {
				state.loadingTransactions = true;
			})
			.addMatcher(TransactionsAPI.endpoints.getTransactions.matchFulfilled, (state, action) => {
				state.loadingTransactions = false;
				state.transactions = action.payload.items;
				state.totalItems = action.payload.totalItems || 0;
			})
			.addMatcher(TransactionsAPI.endpoints.getTransactions.matchRejected, state => {
				state.loadingTransactions = false;
			})
			.addMatcher(TransactionsAPI.endpoints.getAdminTransactions.matchPending, state => {
				state.loadingTransactions = true;
			})
			.addMatcher(TransactionsAPI.endpoints.getAdminTransactions.matchFulfilled, (state, action) => {
				state.loadingTransactions = false;
				state.adminTransactions = action.payload.items;
				state.totalItems = action.payload.totalItems || 0;
			})
			.addMatcher(TransactionsAPI.endpoints.getAdminTransactions.matchRejected, state => {
				state.loadingTransactions = false;
			})
});

// export const {} = ordersSlice.actions;
export const getFullTransactionState = (state: RootState): transactionsState => state.transactions;
export default transactionsSlice.reducer;
